<template>
    <div class="dropzone">
        <div class="dropzone-container">
            <input type="file" @change="onChange" ref="input" multiple accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.gif$">
            <p class="text-center">
                Solte os arquivos aqui
                <br />
                ou
                <br />
                <button>Clique aqui</button>
            </p>
        </div>
        <ul>
            <li v-for="arquivo in arquivos" :key="arquivo.uid">
                {{ arquivo.name }}
                <a @click="e => remover(arquivo.uid)"><i class="mdi mdi-close-thick"></i></a>
            </li>
        </ul>
    </div>
</template>
<script>
import { blobToSHA1 as sha1 } from 'file-to-sha1';
export default {
    props: ['value'],
    data() {
        return {
            arquivos: []
        }
    },
    methods: {
        async onChange() {
            let files = [...this.$refs.input.files];
            let uids = this.arquivos.map(({ uid }) => uid);
            for(let file of files) {
                file.uid = await sha1(file);
            }
            files = files.filter(({ uid }) => !uids.includes(uid));

            this.$emit('input', [...this.arquivos, ...files]);
        },
        remover(uid) {
            let files = this.arquivos.filter(file => file.uid != uid);
            this.$emit('input', files);
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(value) {                
                this.arquivos = value||[];
            }
        }
    }
}
</script>
<style lang="less">
    @import '../css/colors.less';
</style>
<style lang="less" scoped>
    .dropzone {
        padding: 1em 0;
        .dropzone-container {
            position: relative;
            border: 2px dashed gray;
            min-height: 200px;
            display: flex;
            justify-content: center;
            align-items: center;
            input {
                opacity: 0;
                background-color: red;
                position: absolute;
                width: 100%;
                height: 100%;
                left: 0;
                right: 0;
                bottom: 0;
                right: 0;
                margin: 0;
            }
        }
        ul {
            list-style: none;
            display: flex;
            margin: 0;
            padding: 0;
            width: 100%;
            flex-wrap: wrap;
            li {
                display: flex;
                align-items: center;
                background: var(--grey);
                margin-top: 0.5em;
                margin-right: 0.5em;
                padding-left: 1em;
                a {
                    color: black;
                    cursor: pointer;
                    padding: 1em;
                    line-height: 1;
                }
            }
        }
    }
</style>